export async function duplicateItem(type, key, forcedValue, opts) {
  if (!type || !key) {
    return this.error('Type or key is not defined for create operation')
  }

  const item = this.call(
    'deepClone',
    forcedValue?.value ? forcedValue : this.call('getItem', key, type)
  )

  if (!item) {
    this.call('openNotification', {
      type: 'error',
      title: 'Could not find target element',
      message: `We could not find ${key} in ${type}`
    })
    return this.error('Could not find target element')
  }

  const altKey = this.call('findNewName', type, key)
  if (!altKey) {
    this.call('openNotification', {
      type: 'error',
      title: 'Could not duplicate',
      message: `We could not rename ${key} to ${altKey}`
    })
    return this.error('Could not duplicate')
  }
  item.key = altKey

  if (this.call('hasArtboard', type)) {
    if (item.settings.gridOptions.y) {
      item.settings.gridOptions.y += 2
    }
  }

  await this.call('createItem', type, altKey, item, opts)

  this.testAll(`Duplicating ${key} as ${altKey} in ${type}`, () => [
    this.testCase(
      'Item exists in root state',
      'exists',
      this.getSchemaItem(altKey, type) && this.getDataItem(altKey, type)
    )
  ])

  return item
}
